import React from 'react'

const PresenceContext = React.createContext({
  updatePresenceContext: ctx => {},
})

export { PresenceContext }
